module.exports = __webpack_public_path__ + "img/floor-wulianwang.114811fa.png";